import { useRouter } from 'next/router'

const defaultParser = (value) => value

const useRouterQueryStateValue = (name, { defaultValue = null, parser = defaultParser }) => {
  const router = useRouter()

  const routerValue = router.query[name]
  const currentValue = routerValue ? parser(routerValue) : defaultValue

  const updateRoute = (newValue) => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          [name]: newValue,
        },
      },
      undefined,
      { shallow: true }
    )
  }

  return [currentValue, updateRoute]
}

export default useRouterQueryStateValue
